import NCPropertiesProvider from './ncModeler';

export default {
	__init__: [ 'propertiesProvider' ],
	propertiesProvider: [ 'type', NCPropertiesProvider ],
};